





































import { PartnerPracticeApi } from '@/api/partner-practice';
import { CreateClientRequest } from '@/api/requests/clients/create-client-request';
import { PartnerPractice } from '@/shared/partner-practice';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { PartnerPracticeType } from '@/shared/types/partner-practice-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const partnerPracticeApi = new PartnerPracticeApi();

@Component
export default class AddClientAccountDetails extends Vue {
    @typesModule.Getter('activeClientStatusTypes') private clientStatusTypes!: Array<ClientStatusType>;
    @typesModule.Getter('activeClientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;
    @typesModule.Getter('activePartnerPracticeTypesForCurrentUser') private partnerPracticeTypes!: Array<PartnerPracticeType>;

    @Prop({ required: true }) private client!: CreateClientRequest;

    private selectedPartnerPractice: PartnerPractice | null = null;

    private get isIntroducerDisabled(): boolean {
        return this.client.id != null || this.client.partnerPracticeId == null;
    }

    private get isRlgAcquisition(): boolean {
        return this.client.partnerPracticeId! === '00000000-0000-0000-0000-000000000000';
    }

    private get filteredClientOriginalSourceTypes(): Array<ClientOriginalSourceType> {
        let originalSourceTypes: Array<ClientOriginalSourceType>;

        if (this.isRlgAcquisition) {
            originalSourceTypes = [... this.clientOriginalSourceTypes.filter((type) => type.isValidForAcquisition)];
        } else if (this.selectedPartnerPractice == null) {
            return [];
        } else {
            originalSourceTypes = [... this.clientOriginalSourceTypes.filter((type) => this.selectedPartnerPractice!.originalSourceTypes.some((t) => t === type.id))];
        }

        return originalSourceTypes.sort((t1, t2) => {
            if (t1.value > t2.value) { return 1; }
            if (t1.value < t2.value) { return -1; }
            return 0;
        });
    }

    @Watch('client.partnerPracticeId', { immediate: true })
    private async onClientPartnerPracticeIdChanged(): Promise<void> {
        if (this.client.partnerPracticeId == null) {
            this.client.originalSourceId = null;
            this.selectedPartnerPractice = null;
            return;
        }

        if (this.isRlgAcquisition) {
            const clientOriginalSourceType = this.clientOriginalSourceTypes.find((type) => type.id === this.client.originalSourceId);

            if (clientOriginalSourceType == null || !clientOriginalSourceType.isValidForAcquisition) {
                this.client.originalSourceId = null;
            }

            return;
        }

        this.selectedPartnerPractice = await partnerPracticeApi.getPartnerPracticeAsync(this.client.partnerPracticeId!);

        if (!this.selectedPartnerPractice.originalSourceTypes.some((type) => type === this.client.originalSourceId!)) {
            this.client.originalSourceId = null;
        }
    }
}
